import type { ComponentType } from '@grafikr/components';
import fastdom from 'fastdom';
import { fromEvent } from 'rxjs';

const Component: ComponentType = (node) => {
  const CLASSES = {
    active: 'header__announcement--active',
  };
  let isActive = true;

  const show = () => {
    isActive = true;

    fastdom.mutate(() => {
      node.classList.add(CLASSES.active);
    });
  };

  const hide = () => {
    isActive = false;

    fastdom.mutate(() => {
      node.classList.remove(CLASSES.active);
    });
  };

  const resizeObserver = new ResizeObserver(() => {
    node.style.setProperty('--height', `${node.clientHeight}px`);
  });

  resizeObserver.observe(node);

  fromEvent(document, 'scroll', { passive: true }).subscribe(() => {
    const scroll = document.documentElement.scrollTop || document.body.scrollTop;

    if (scroll >= 50 && isActive) {
      hide();
    } else if (scroll < 50 && !isActive) {
      show();
    }
  });
};

export default Component;
